import { EventsPopoverController } from './eventsPopoverController';
export class EventsController {
  constructor(parent, mapView, key, info) {
    this._parent = parent;
    this._key = key;
    this._mapView = mapView;
    this._info = info;
    this._tween = swim.Transition.duration(350);
    this._fillColor = swim.Color.parse('#44D7B6');
    this._strokeColor = swim.Color.parse('#4BD744');
    this._dimColor = swim.Color.parse('#9c9d9f');

    this._color = swim.Color.white();

    this._heatMapLink = null;
    this._heatMapName = null;
    this._density = 0;

    // Data
    this._lng = { value: info.get('lon').numberValue(0), dirty: true };
    this._lat = { value: info.get('lat').numberValue(0), dirty: true };
    this._rad = { value: 0, dirty: true };

    // Create Geofence on map
    this._geofence = new swim.MapCircleView()
      .center([this._lng.value, this._lat.value])
      .radius(10)
      .fill(swim.Color.transparent())
      .stroke(swim.Color.transparent())
      .strokeWidth(2);

    this._mapView.view.setChildView(`${this._key}-geofence`, this._geofence);

    // Create Marker on map
    this._marker = new swim.MapCircleView()
      .center([this._lng.value, this._lat.value])
      .radius(5)
      .fill(swim.Color.transparent());

    this._mapView.view.setChildView(`${this._key}-marker`, this._marker);
    this._marker.on("click", this.onClickVehicle.bind(this));

    this.update(info);
    this.init();
  }

  init() {
    this._marker.fill(swim.Color.transparent());
    this._geofence.fill(swim.Color.transparent())
      .stroke(this._strokeColor);
  }

  get color() {
    return this._color;
  }

  get density() {
    return this._density;
  }

  update(info) {
    this._info = info;
    this._heatMapName = info.get('name').stringValue();

    const lng = info.get('lon').numberValue(0);
    if(lng !==  this._lng.value) {
      this._lng.value = lng;
      this._lng.dirty = true;
    }
    const lat = info.get('lat').numberValue(0);
    if(lat !== this._lat.value) {
      this._lat.value = lat;
      this._lat.dirty = true;
    }

    const rad = info.get('rad').numberValue(0);
    if(rad !== this._rad) {
      this._rad.value = rad;
      this._rad.dirty = true;
    }

  }

  render() {
    if(this._lng.dirty || this._lat.dirty) {
      this._marker.center([this._lng.value, this._lat.value], this._tween);
      this._geofence.center([this._lng.value, this._lat.value], this._tween);
      this._lng.dirty = false;
      this._lat.dirty = false;
    }

    if(this._rad.dirty) {
      const zoomLevel = this._mapView.map.getZoom();
      this.zoomUpdate(zoomLevel);
      this._rad.dirty = false;
    }

    if(this._parent.heatMap) {
      this.linkHeatMap();
      const color = (this._parent.noTag || this._parent.showCrush)? this._dimColor: this._fillColor;
      // console.log('color: ', color);
      this._geofence.fill(color.alpha( Math.min(this._density, 0.75)));
    } else {
      this.unlinkHeatMap();
    }

    let color = (this._parent.noTag || this._parent.showCrush)? this._dimColor : this._strokeColor;
    this._color = color;
    this._geofence.stroke(color);
  }

  linkHeatMap() {
    if(!this._heatMapLink) {
      this._heatMapLink = swim.downlinkValue().hostUri(CONFIG.host).nodeUri(`/geoFence/${CONFIG.country}/${this._heatMapName}`).laneUri('density')
        .didSet((v)=> {
          this._density = v.numberValue(0);
        }).open();
    }
  }

  unlinkHeatMap() {
    if(this._heatMapLink) {
      this._heatMapLink.close();
      this._heatMapLink = null;
      this._density = 0;
      this._geofence.fill(swim.Color.transparent());
    }
  }

  onClickVehicle(event) {
    event.stopPropagation();
    if (!this._popoverView) {
      this._popoverView = new EventsPopoverController(this, this._marker, this._info);
    }

    this._popoverView.update(this._info);
    this._mapView.appView.togglePopover(this._popoverView.view, {multi: event.altKey});
  }

  remove() {
    if(this._popoverView) {
      this._popoverView.view.remove();
      this._popoverView = null;
    }
    this._marker.remove();
    this._geofence.remove();
  }

  kmToPixel(latitude, km, zoomLevel) {
    const earthCircumference = 40075017;
    const latitudeRadians = latitude * (Math.PI/180);
    const metersPerPixel = earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoomLevel + 8);
    const meter = km * 1000;

    return meter / metersPerPixel;
  }

  zoomUpdate(zoomLevel) {
    const r = this.kmToPixel(this._lat.value, this._rad.value,  zoomLevel);
    if(this._geofence) {
      this._geofence.radius(r, this._tween);
    }
  }
}
